<template>
  <PageContentLayoutOnly>
    <ListEscrowConversations :escrowID="parseInt(escrowID)" />
  </PageContentLayoutOnly>
</template>

<script>
import { mapState } from 'vuex'
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
import ListEscrowConversations from '@/pages/Shared/communications/Global/List'

import { methods } from './keys/methods'
import { data } from './keys/data'

export default {
  name: 'EscrowConversations',

  components: {
    PageContentLayoutOnly,
    ListEscrowConversations
  },

  data,
  methods,

  computed: {
    ...mapState({
      hoaId: state => state.user.selectedHoaId
    })
  },

  watch: {},

  mounted() {
    this.reload()
  },

  i18n: {
    messages: {
      en: { escrowConversations: { title: 'Conversations' } }
    }
  }
}
</script>

<style></style>
